export default {
  props: {
    filters: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      internal_filters: null,
      skip: 0,
      limit: 20,
    };
  },
  methods: {
    get_skip() {
      return this.skip;
    },
    get_limit() {
      return this.limit;
    },
    append_paging_params(my_url) {
      my_url.searchParams.set("skip", this.get_skip());
      my_url.searchParams.set("limit", this.get_limit());
    },
    append_order_params(my_url) {
      my_url.searchParams.set("order_by", "id-");
    },
    append_filters_params(my_url, filters) {
      if (!filters) return;
      Object.keys(filters).forEach((k) => {
        if (k in filters && !(filters[k] === "" || filters[k] === null)) {
          my_url.searchParams.append(k, filters[k]);
        }
      });
    },
    get_url() {
      return "/";
    },
    async actual_fetch_data() {
      const fetch_url = new URL("http://test" + this.get_url());
      this.append_paging_params(fetch_url);
      this.append_order_params(fetch_url);
      this.append_filters_params(fetch_url, this.filters);
      this.append_filters_params(fetch_url, this.internal_filters);
      let path = fetch_url.pathname + fetch_url.search + fetch_url.hash;
      return await this.pyx_api.get(path);
    },
  },
};
